
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FiUpload } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

const DropzoneImageUpload = ({ setUploadFile, componentFor }) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setSelectedFile(file);
            setUploadFile(file);
        }
    }, [setUploadFile]);

    const removeFile = () => {
        setSelectedFile(null);
        setUploadFile(null);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: "image/*",
        multiple: false,
    });

    return (
        <div
            {...getRootProps()}
            className="border-2 border-dashed border-gray-300 p-4 text-center cursor-pointer rounded-lg hover:border-blue-500"
        >
            <input {...getInputProps()} />
            {selectedFile ? (
                <div className="flex justify-between items-center bg-gray-100 p-2 rounded-lg">
                    <span className="text-gray-600 text-sm truncate max-w-[80%]">
                        {selectedFile.name}
                    </span>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            removeFile();
                        }}
                        className="text-red-500 hover:text-red-700"
                    >
                        <IoClose size={20} />
                    </button>
                </div>
            ) : (
                <div className="flex flex-col items-center">
                    <FiUpload className="text-gray-600 text-2xl mb-2" />
                    <p className="text-gray-600 text-sm">
                        Drag & drop or click to upload {componentFor}
                    </p>
                </div>
            )}
        </div>
    );
};

export default DropzoneImageUpload;
